<template>
    <div>
        <el-input
            v-if="mode == 'edit'"
            v-model="currentValue"
            min="0"
            max="100"
            :placeholder="placeholder"
            :data-bot="dataBot"
            @change="update"
            @blur="formatAmount"
        >
            <template #append>%</template>
        </el-input>
        <p v-else>{{ currentValue }} %</p>
    </div>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
            default: '',
        },
        value: {
            type: [Number, String],
            required: false,
            default: 0,
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        dataBot: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            numberFormat: window.App.numformat,
            currentValue: this.value,
        };
    },
    watch: {
        value(newValue, oldValue) {
            if (newValue != oldValue) {
                this.currentValue = newValue;
            }
        },
    },
    created() {
        this.numberFormat = { ...window.App.numformat };
        this.numberFormat.precision = 0;

        this.currentValue = NumberFormat.formatToDisplay(this.value, this.numberFormat);
    },
    methods: {
        formatAmount() {
            if (!this.currentValue) {
                this.currentValue = 0;
            }
            this.currentValue = parseInt(this.currentValue);
            if (this.currentValue > 100) {
                this.currentValue = 100;
            }
            this.currentValue = NumberFormat.formatToDisplay(this.currentValue, this.numberFormat);
        },
        update(newVal) {
            this.$emit('input', newVal);
        },
    },
};
</script>
